import React, { useEffect, useState } from 'react'

import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router-dom'
// import ReactTooltip from 'react-tooltip'

import Button from '../../components/common/button/Button'
import DataTable from '../../components/common/dataTable/DataTable'
import DataTableCol from '../../components/common/dataTable/DataTableCol'
import DataTableHeader from '../../components/common/dataTable/DataTableHeader'
import DataTableHeaderCol from '../../components/common/dataTable/DataTableHeaderCol'
import DataTableRow from '../../components/common/dataTable/DataTableRow'
import { DateMapper } from '../../components/common/dateMapper/DateMapper'
import Icon from '../../components/common/icon/Icon'
import MessageFeedback from '../../components/common/messageFeedback/MessageFeedback'
import Pager from '../../components/common/pager/Pager'
import Personalization from '../../components/common/personalization/Personalization'
import LoadingSpinner from '../../components/common/spinner/LoadingSpinner'

import { getMessageDetails } from '../../api/beEmailMessageApi/BeEmailMessageApi'
import { getListDataById } from '../../api/beListApi/BeListApi'
import { getRecipientEmail } from '../../api/beRecipientApi/BeRecipientApi'
import { getMessageEventsBounces } from '../../api/statisticsApi/StatisticsApi'

import batchPromises from '../../services/batchPromises'

const PAGE_STATUS_READY = 'PAGE_STATUS_READY'
const PAGE_STATUS_ERROR = 'PAGE_STATUS_ERROR'
const PAGE_STATUS_PARAMS_ERROR = 'PAGE_STATUS_PARAMS_ERROR'
const PAGE_STATUS_LOADING = 'PAGE_STATUS_LOADING'

const initialPageState = {
  pageStatus: PAGE_STATUS_LOADING,
  pageNumber: 1,
  pageSize: 10,
  noData: false,
  loadData: true,
  dettMode: false
}

const initialData = {
  totalItems: 0,
  items: []
}

let timeZoneCode = ''

// http://localhost:1234/frontend/bouncelog/listGuid/E5EBB6B6-DE5E-4060-8E68-B89EE9FA2587/idList/1/idNL/14095
// https://d6x1a.spediremail.it/frontend/bouncelog/listGuid/E5EBB6B6-DE5E-4060-8E68-B89EE9FA2587/idList/1/idNL/14095

// OLD
// http://localhost:1234/frontend/bounce_log.aspx?idList=1&listGuid=e5ebb6b6-de5e-4060-8e68-b89ee9fa2587&idnl=14095
const BounceLog = ({ match, history, location, intl }) => {
  const [pageState, setPageState] = useState(initialPageState)
  const [data, setData] = useState(initialData)
  const [msgDett, setMsgDett] = useState({})
  const [listDett, setListDett] = useState({})
  const [bounceDett, setBounceDett] = useState({})
  // const [loadData, setLoadData] = useState(true)

  const listGuid = match.params.listGuid
  const idList = parseInt(match.params.idList)
  const idNl = parseInt(match.params.idNL)

  function convertDateUtctoCTZ(dateString) {
    const dateInstance = new Date(dateString)
    // const tmp = new Date(dateInstance.getTime() + dateInstance.getTimezoneOffset() * 60000)
    // debugger
    return DateMapper.toLocalDate(dateInstance, timeZoneCode)
  }

  useEffect(() => {
    if (pageState.loadData) {
      getListDataById(idList, listGuid)
        .then((listDetails) => {
          setListDett(listDetails)
          timeZoneCode = listDetails.TimeZoneCode

          return Promise.all([
            getMessageDetails(idList, listGuid, idNl, false),
            getMessageEventsBounces(idList, listGuid, idNl, pageState.pageSize, pageState.pageNumber, '', '', 'BounceOrderbyDate', true)
          ])
            .then(([messageDetails, listBounce]) => {
              setMsgDett(messageDetails)
              setData((prevState) => ({ ...prevState, totalItems: listBounce.TotalItems, items: listBounce.EventList }))
              setPageState((prevState) => ({ ...prevState, pageStatus: PAGE_STATUS_READY, loadData: false }))

              if (listBounce.EventList.length > 0) {
                const recIds = listBounce.EventList.map(o => o.IdRecipient)
                batchPromises(recIds, 10, getRecipientDett)
                setPageState((prevState) => ({ ...prevState, noData: false }))
              } else {
                setPageState((prevState) => ({ ...prevState, noData: true }))
              }
            })
        })
        .catch(() => {
          setPageState((prevState) => ({ ...initialPageState, pageStatus: PAGE_STATUS_ERROR, loadData: false }))
        })
    }
  }, [pageState.loadData])

  function getRecipientDett(idRecipient) {
    return getRecipientEmail(idList, listGuid, idRecipient)
      .then((resp) => {
        setData((prevState) => ({
          ...prevState,
          items: prevState.items.map((o) => ((o.IdRecipient === idRecipient) ? { ...o, RecipientEmail: resp } : o))
        }))
        return idRecipient
      })
      .catch(() => {
        setData((prevState) => ({
          ...prevState,
          items: prevState.items.map((o) => ((o.IdRecipient === idRecipient) ? { ...o, RecipientEmail: <Icon family='fa' icon='exclamation-triangle' className='text-light' /> } : o))
        }))
        return idRecipient
      })
  }

  const personalizationProps = {
    idList: idList,
    showLogo: true,
    applyCustomCSS: true
  }

  const pagerProps = {
    currentPage: pageState.pageNumber,
    itemsPerPage: pageState.pageSize,
    totalItems: data.totalItems,
    onChange: onChangePager,
    ofLabel: intl.formatMessage({ id: 'Load.Pager.Of' }),
    itemsLabel: intl.formatMessage({ id: 'Load.Pager.Items' }),
    className: 'test-BouneLogPubb-paging'
  }

  const propsBackBtn = {
    children: intl.formatMessage({ id: 'Load.Common.BtnBack' }),
    kind: 'secondary',
    onClick: goToList,
    className: 'test-BouneLogPubb-goToList f-right'
  }

  function reloadPage() {
    setPageState((prevState) => ({ ...initialPageState, pageStatus: PAGE_STATUS_LOADING, loadData: true }))
  }

  function onChangePager(val) {
    setPageState((prevState) => ({ ...prevState, pageStatus: PAGE_STATUS_LOADING, pageSize: val.pageSize, pageNumber: val.pageNumber, loadData: true }))
  }

  function goToDett(item) {
    setBounceDett(item)
    setPageState((prevState) => ({ ...prevState, dettMode: true }))
  }

  function goToList() {
    setPageState((prevState) => ({ ...prevState, dettMode: false }))
  }

  // on update messages details

  return (
    <div className='frontend-wrapper-xl'>
      {(pageState.pageStatus === PAGE_STATUS_LOADING) &&
        <LoadingSpinner />}

      {(pageState.pageStatus === PAGE_STATUS_PARAMS_ERROR) &&
        <MessageFeedback kind='error'>{intl.formatMessage({ id: 'Load.Statistics.ErrorDisplayingReport' })}</MessageFeedback>}

      {(pageState.pageStatus === PAGE_STATUS_ERROR) &&
        <MessageFeedback kind='error'>
          {intl.formatMessage({ id: 'Load.Statistics.ErrorLoadingData' })}
          <a className='frontend-p-left-xs-thin test-BouneLogPubb-ReloadData' onClick={reloadPage}>{intl.formatMessage({ id: 'Load.MailupCommon.ReloadData' })}</a>
        </MessageFeedback>}

      {(pageState.pageStatus === PAGE_STATUS_READY) &&
        <>
          <Personalization {...personalizationProps} />

          {!pageState.dettMode
            ? <>
              <div className='frontend-row frontend-box'>
                <h1 className='frontend-m-bottom-x-sm '><b>{intl.formatMessage({ id: 'Load.bounceLogFrontend.Title' })}</b></h1>
                <p className='frontend-m-bottom-xx-sm'>
                  <b>{intl.formatMessage({ id: 'Load.MailupCommon.Message' })}:</b>&nbsp;
                  <span>ID {idNl} - {msgDett.Subject} </span>
                </p>
                <p className='frontend-m-bottom'>
                  <b>{intl.formatMessage({ id: 'Load.MailupCommon.List' })}:</b>&nbsp;
                  <span>{idList} - {listDett.Name} </span>
                </p>

                {(pageState.noData)
                  ? <div className='frontend-row_reset frontend-p-bottom'>
                    <h3>{intl.formatMessage({ id: 'Load.EmailMessageList.EmptyStateActiveRecipientBouncesTitle' })}</h3>
                    <p>{intl.formatMessage({ id: 'Load.BounceFrontend.EmprtyStateDescr' })}</p>
                  </div>
                  : <>
                    <p className='frontend-m-bottom'>{intl.formatMessage({ id: 'Load.bounceLogFrontend.SubTitle' })}</p>
                    <DataTable>
                      <DataTableHeader>

                        <DataTableHeaderCol width='2'>{intl.formatMessage({ id: 'Load.MailupCommon.Type' })}</DataTableHeaderCol>
                        <DataTableHeaderCol className='frontend-p-right' width='6'>{intl.formatMessage({ id: 'Load.MailupCommon.Email' })}</DataTableHeaderCol>
                        <DataTableHeaderCol width='2'>{intl.formatMessage({ id: 'Load.MailupCommon.Date' })}</DataTableHeaderCol>
                        <DataTableHeaderCol width='2' className='frontend-text-right' />
                      </DataTableHeader>
                      {data.items.map((item, index) => renderItem(item, index))}
                    </DataTable>
                    <Pager {...pagerProps} />
                  </>}
              </div>
            </>
            : <>
              <div className='frontend-row'>
                <div className='col-xs-2' />
                <div className='col-xs-8'>
                  <div className='frontend-row frontend-box'>
                    <h1 className='frontend-m-bottom d-inline-block'><b>{intl.formatMessage({ id: 'Load.BounceFrontend.BounceDetails' })}</b></h1>
                    <Button {...propsBackBtn} />
                    <div className='frontend-row frontend-row_reset'>
                      <div className='col-xs-2 frontend-p-left-0'><b>{intl.formatMessage({ id: 'Load.MailupCommon.List' })}:</b></div>
                      <div className='col-xs-10 frontend-p-right-0'><span>{idList} - {listDett.Name} </span></div>
                    </div>
                    <div className='frontend-row frontend-row_reset'>
                      <div className='col-xs-2 frontend-p-left-0'><b>{intl.formatMessage({ id: 'Load.MailupCommon.Message' })}:</b></div>
                      <div className='col-xs-10 frontend-p-right-0'><span>ID {idNl} - {msgDett.Subject}</span> </div>
                    </div>
                    <div className='frontend-row frontend-row_reset'>
                      <div className='col-xs-2 frontend-p-left-0'><b>{intl.formatMessage({ id: 'Load.MailupCommon.Recipient' })}:</b></div>
                      <div className='col-xs-10 frontend-p-right-0'><span>{bounceDett.RecipientEmail}</span> </div>
                    </div>
                    <div className='frontend-row frontend-row_reset'>
                      <div className='col-xs-2 frontend-p-left-0'><b>{intl.formatMessage({ id: 'Load.MailupCommon.Type' })}:</b></div>
                      <div className='col-xs-10 frontend-p-right-0'><span>{bounceDett.BounceType}</span> </div>
                    </div>
                    <div className='frontend-row frontend-row_reset'>
                      <div className='col-xs-2 frontend-p-left-0'><b>{intl.formatMessage({ id: 'Load.MailupCommon.Date' })}:</b></div>
                      <div className='col-xs-10 frontend-p-right-0'><span>{DateMapper.datetimeToSTring(convertDateUtctoCTZ(bounceDett.BounceDateJs))} {timeZoneCode.split(':')[0]}</span> </div>
                    </div>
                    {bounceDett.RawMsg &&
                      <div className='frontend-row frontend-row_reset'>
                        <div className='col-xs-2 frontend-p-left-0'><b>{intl.formatMessage({ id: 'Load.Common.Detail' })}:</b></div>
                        <div className='col-xs-10 frontend-p-right-0'><p>{bounceDett.Subject}</p><p>{bounceDett.RawMsg}</p> </div>
                      </div>}

                  </div>
                  <p>{intl.formatMessage({ id: 'Load.BounceFrontend.note_1' }, {
                    strong: chunks => <strong>{chunks}</strong>
                  })} </p>
                  <p className='frontend-m-bottom'>{intl.formatMessage({ id: 'Load.BounceFrontend.note_2' }, {
                    strong: chunks => <strong>{chunks}</strong>
                  })}</p>
                </div>
              </div>
            </>}

        </>}

    </div>
  )

  function renderItem(item, index) {
    // const subject = (item.Subject) ? `ID ${item.IdMessage} - ${item.Subject}` : ''

    return (
      <DataTableRow key={index}>

        <DataTableCol width='2'>{item.BounceType}</DataTableCol>
        <DataTableCol className='frontend-p-right' width='6'>{item.RecipientEmail ? item.RecipientEmail : <p className='is-loading' />}</DataTableCol>
        <DataTableCol width='2'>{DateMapper.datetimeToSTring(convertDateUtctoCTZ(item.BounceDateJs))} {timeZoneCode.split(':')[0]}</DataTableCol>
        <DataTableCol width='2' className='frontend-text-right '><a className='frontend-link-highlight test-BouneLogPubb-goToDett' onClick={() => goToDett(item)}>{intl.formatMessage({ id: 'Load.Common.Detail' })}</a></DataTableCol>

      </DataTableRow>
    )
  }
}

export default injectIntl(withRouter(BounceLog))
